<template>
  <div class="export-progress-loader">
    <div class="export-progress-loader__header"><span class="export-progress-loader__header-status">{{ status }}</span> - stay on this tab for best performance.</div>
    <progress-bar
      class="export-progress-loader__progress-bar"
      :completedPercentage="progressPercentage"
    >
    </progress-bar>
    <div class="export-progress-loader__inner">
      <export-detail
        class="export-progress-loader__video-duration"
        label="Video duration: "
        :value="duration"
      >
      </export-detail>
      <export-detail
        class="export-progress-loader__aspect-ratio"
        label="Aspect ratio: "
        :value="orientation"
      >
      </export-detail>
      <export-detail
        label="File format: "
        :value="format"
      >
      </export-detail>
      <export-detail
        class="export-progress-loader__completed-percentage"
        label=""
        :value="completedPercentageFormatted"
        :is-value-large-size="true"
      >
      </export-detail>
    </div>
  </div>
</template>
<script setup lang="ts">
import ExportDetail from '@/components/export/ExportDetail.vue'
import ProgressBar from '@/components/export/ProgressBar.vue'
import { useExportStore } from '@/store/export-store'
import { useProjectStore } from '@/store/project-store'
import { computed } from 'vue'

const projectStore = useProjectStore()
const exportStore = useExportStore()

const completedPercentageFormatted = computed(() => {
  const progressPercentageLimited = progressPercentage.value > 99 ? 99 : progressPercentage.value
  return progressPercentageLimited.toFixed(0) + '%'
})

const status = computed(() => progressPercentage.value < 99 ? 'Rendering your video' : 'Finalizing your video')

const duration = computed(() => new Date(exportStore.durationMilliseconds).toISOString().slice(14, 19))
const orientation = computed(() => {
  switch (projectStore.orientation) {
  case 'portrait': {
    return 'Portrait 9:16'
  }
  case 'landscape': {
    return 'Landscape 16:9'
  }
  case 'square': {
    return 'Square 1:1'
  }
  default: {
    return ''
  }
  }
})
const format = computed(() => exportStore.fileFormat.toUpperCase())
const progressPercentage = computed(() => {
  const percentage = (exportStore.elapsedMilliseconds/(exportStore.durationMilliseconds)) * 100
  if (percentage < 0 || percentage > 100) {
    return percentage < 0 ? 0 : 100
  }
  return percentage
})
</script>

<style lang="scss">
.export-progress-loader {
  white-space: pre-wrap;
  margin-left: 20px;
  margin-right: 20px;
  &__header {
    color: $white;
    font-size: 20px;
    font-family: $font-regular;
    margin-bottom: 24px;

    &-status {
      font-family: $font-bold;
    }
  }
  &__progress-bar {
    margin-bottom: 20px;
  }
  &__inner {
    display: flex;
    margin-bottom: 24px;
  }
  &__video-duration {
    margin-right: 20px;
  }
  &__aspect-ratio {
    margin-right: 20px;
  }
  &__completed-percentage {
    flex: 1;
    display: flex;
    &:before {
      content: "";
      flex: 1;
    }
  }
}
</style>
